import { COPYRIGHT_ENGLISH } from "../constants.js";
export const zh = {
    "Notice": "Notice",
    "No slots available for the selected period.": "No slots available for the selected period.",
    "welcome_back": "欢迎回来",
    "login_subtitle": "请登录以继续。",
    "login_tos_prefix": "登录即表示您同意我们的",
    "terms_of_service": "服务条款",
    "help": "帮助",
    "privacy": "隐私",
    "imprint": "印记",
    "or": "或",
    "google": "Google",
    "sso_icon_alt": "SSO 图标",
    "SSO": "SSO",
    "these_zesty_duck_nudge": "基本信息",
    "north_least_gopher_burn": "此预约类型的目的是什么？",
    "lazy_just_duck_spin": "事件标题",
    "Confirm meeting": "确认会议",
    "Meeting with {{name}}": "与 {{name}} 会面",
    "Daily availability": "每日可用性",
    "tiny_factual_platypus_pave": "会议在哪里举行？",
    "less_equal_octopus_dine": "URL 的可自定义部分",
    "quiet_male_yak_slurp": "事件 Slug",
    "honest_weak_iguana_rest": "地点",
    "dizzy_quiet_walrus_hush": "awesome-meeting",
    "tired_whole_bumblebee_type": "Zoom 会议",
    "these_moving_fox_create": "描述",
    "quaint_known_wasp_view": "最少提前天数",
    "pretty_grand_cuckoo_arrive": "事件不能在少于此时间之前安排",
    "slow_maroon_spider_praise": "每天此类事件的最大数量",
    "grand_wacky_ox_flow": "每天最大",
    "left_aloof_stork_leap": "缓冲-前",
    "elegant_early_boar_accept": "此事件持续多长时间？",
    "ideal_this_coyote_inspire": "持续时间",
    "jumpy_tasty_rook_trust": "持续时间",
    "real_big_crow_push": "此事件前的缓冲",
    "mealy_happy_ray_flop": "缓冲前",
    "close_actual_deer_boil": "缓冲后",
    "keen_zippy_bulldog_gaze": "此事件后的缓冲",
    "seemly_fine_octopus_slurp": "可用性",
    "each_awake_tadpole_jest": "编辑事件类型",
    "extra_patient_warbler_praise": "没有可预订的事件",
    "petty_swift_piranha_rise": "安排事件",
    "broad_close_butterfly_drop": "安排与 {{name}} 的预约",
    "weary_known_gazelle_file": "请选择您需要的预约类型，然后单击安排按钮进行预订。您将获得我日程安排中可用时段的列表。",
    "low_clean_haddock_bubble": "我的事件类型",
    "My Event Types": "我的事件类型",
    "pink_trite_ocelot_enrich": "您需要先连接日历，然后才能添加事件！",
    "early_sweet_mantis_peek": "添加事件类型",
    "deft_suave_bear_pause": "加载中",
    "equal_jolly_thrush_empower": " 分钟",
    "Schedule an appointment": "安排预约",
    "heroic_kind_llama_zip": "返回",
    "awake_jolly_gazelle_lock": "跳过",
    "whole_acidic_parrot_promise": "预订预约",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "步骤 {{val}}",
    "extra_misty_panda_grip": "用户可以使用此链接预订预约。",
    "sunny_great_halibut_empower": "创建第一个",
    "create_first_event_type_button": "事件类型",
    "application_title": "Appoint Me",
    "orange_grand_racoon_fall": "{{app_title}} 如何工作",
    "male_patient_hedgehog_ask": "{{app_title}} 一个简单易用的预约预订系统。它允许您创建事件，分享您的链接并让用户与您预约。",
    "factual_moving_hawk_belong": "指定 {{app_title}} 在哪里添加您的预约以及在哪里检查您是否忙碌。",
    "step_1_configure_calendars": "步骤 1：配置日历",
    "pink_polite_racoon_earn": "步骤 2：创建事件",
    "happy_wise_mantis_laugh": "“添加您的可用时间，就可以了！”",
    "careful_misty_bullock_splash": "步骤 3：分享您的链接",
    "game_frail_vole_treasure": "完成！恭喜！",
    "still_helpful_koala_trust": "一旦用户预订预约，该事件就会添加到您的日历中。",
    "steep_fine_lobster_inspire": "未能保存事件类型",
    "best_due_parakeet_zip": "事件类型已创建！",
    "happy_caring_fox_spur": "事件已保存",
    "tasty_witty_stingray_hope": "保存事件时出错",
    "trite_warm_gorilla_pet": "将预约添加到日历",
    "aware_alert_mare_glow": "检查日历中的空闲时间",
    "factual_nimble_snail_clap": "保存更改",
    "tiny_teary_clownfish_vent": "取消",
    "lower_born_finch_dash": "断开与 Google 的连接",
    "whole_formal_liger_rise": "连接 Google Calendar",
    "pink_loose_cougar_grin": "我的日历",
    "upper_even_florian_peek": "Google Calendar",
    "merry_north_meerkat_cuddle": "配置",
    "big_known_loris_revive": "选择日历以检查忙碌时间。",
    "large_suave_gull_hush": "复制链接",
    "misty_proud_mallard_assure": "复制链接",
    "teal_lofty_hawk_peek": "取消",
    "mild_raw_elk_delight": "保存更改",
    "Choose date": "选择日期",
    "Please select a date": "请选择日期",
    "Choose time": "选择时间",
    "Provide details": "提供详细信息",
    "Confirmation": "确认",
    "Please share anything that will help me to prepare for our meeting": "请分享任何通过帮助我准备我们的会议",
    "confirmationText_male": "您已在 {{date}} {{time}} 与 {{name}} 预订了 {{event}} 预约。",
    "confirmationText_female": "您已在 {{date}} {{time}} 与 {{name}} 预订了 {{event}} 预约。",
    "confirmationText_neuter": "您已在 {{date}} {{time}} 与 {{name}} 预订了 {{event}} 预约。",
    "Name": "姓名",
    "Please provide your name": "请提供您的姓名",
    "Email": "电子邮件",
    "Information": "信息",
    "You will receive a confirmation email": "您将收到一封确认电子邮件",
    "Meeting with": "与...会面",
    "Change": "更改",
    "Back": "返回",
    "Add Event Type": "添加事件类型",
    "Confirm & Book": "确认并预订",
    "availableSlots": "以下时段在 {{date}} 可用。预订一个或选择另一天。",
    "minutes": "分钟",
    "Days": "天",
    "Maximum days in advance": "最大提前天数",
    "event_advance_availability_description": "此事件类型提前多少天可用？",
    "none": "无",
    "Select buffer": "选择缓冲",
    "Save": "保存",
    "Select duration": "选择持续时间",
    "Starttime": "开始时间",
    "Endtime": "结束时间",
    "Add Account": "添加账户",
    "Add CalDav Account": "添加 CalDav 账户",
    "CalDav Accounts": "CalDav 账户",
    "Server URL": "服务器 URL",
    "Username": "用户名",
    "label_password": "密码",
    "send_invitation_email": "发送邀请邮件",
    "send_invitation_email_notice": "仅当您的 CalDAV 服务器不自动发送邀请时需要。",
    "invitationSubject": "邀请：{{summary}}",
    "invitationBody": "<p>嗨 {{attendeeName}}，</p><p>您已受邀参加以下活动：</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>时间：</strong> {{time}}</p><p>请查阅附件中的活动详情。</p>",
    "icsDescription": "活动描述：\n{{description}}",
    "dateFormat": "zh-CN",
    "user_menu_log_out": "登出",
    "user_menu_log_in": "登录",
    "user_menu_profile": "个人资料",
    "user_menu_my_account": "我的账户",
    "user_menu_calendar_integration": "日历集成",
    "user_menu_copy_link": "复制链接",
    "user_menu_link_copied": "链接已复制",
    "name": "姓名",
    "user_url": "用户链接",
    "use_gravatar": "使用 Gravatar",
    "save": "保存",
    "profile_updated": "个人资料已更新",
    "error_saving_profile": "保存个人资料失败",
    "user_url_taken": "用户链接已被占用",
    "error_loading_profile": "加载个人资料失败",
    "login_with_sso": "使用 SSO 登录",
    "login_with": "登录",
    "login_successful": "登录成功",
    "login_failed": "登录失败",
    "google_login_failed": "Google 登录失败",
    "Add": "添加",
    "edit": "编辑",
    "Close": "关闭",
    "Choose calendars in which appointments are created.": "选择创建预约的日历。",
    "Email (Optional)": "电子邮件（可选）",
    "Enter your CalDav server details to connect your calendar.": "输入您的 CalDav 服务器详细信息以连接您的日历。",
    "Failed to add account. Please check your credentials and server URL.": "添加账户失败。请检查您的凭据和服务器 URL。",
    "I acknowledge that my password will be stored encrypted in the database.": "我确认我的密码将加密存储在数据库中。",
    "event_copy_link": "复制链接",
    "link_copied_to_clipboard": "链接已复制到剪贴板！",
    "link_copy_failed": "无法将链接复制到剪贴板！",
    "copy": "复制",
    "Availability Mode": "可用性模式",
    "Define Custom": "自定义",
    "Use Standard": "使用标准",
    "Standard + Extra": "标准 + 额外",
    "Standard + Constraints": "标准 + 限制",
    "Standard Availability": "标准可用性",
    "Using Standard Availability defined in Profile settings.": "使用配置资料设置中定义的标准可用性。",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "在此处定义您的标准每周可用性。您可以在事件类型中使用此可用性。",
    "Copy Standard Availability": "复制标准可用性",
    "Overwrite current availability with standard?": "用标准覆盖当前的可用性？",
    "Profile": "个人资料",
    "about": "关于",
    "about_content": "# 关于 AppointMe\n\nAppointMe 是一个简单的预约安排工具。\n配置您的日历，设置您的空闲时间，让其他人与您预约。\n\n## Github\n[在 Github 上查看代码](https://github.com/fhswf/appointme)\n\n## 致谢\n由 South Westphalia University of Applied Sciences ❤️ 实现",
    "legal": "法律声明",
    "Calendar": "日历",
    "Select a calendar": "选择日历",
    "No calendar selected": "未选择日历",
    "Calendar settings saved": "日历设置已保存",
    "Failed to save settings": "保存设置失败",
    "Failed to load calendars for": "加载日历失败",
    "Google Calendar disconnected": "Google 日历已断开连接",
    "Failed to disconnect Google Calendar": "断开 Google 日历连接失败",
    "Connect a calendar to get started": "连接日历以开始",
    "Online via Zoom": "通过 Zoom 在线",
    "Language": "语言",
    "page not found": "页面未找到",
    "GO HOME": "返回首页",
    "Impressum": "版本说明",
    "Datenschutzhinweise": "隐私政策",
    "privacy_content": `
# 隐私政策

## 数据收集和使用
本应用程序收集和使用个人数据以提供预约安排服务。

*   **用户资料：** 我们存储您的姓名、电子邮件地址和个人资料图片，以识别您的身份并个性化您的体验。
*   **Google 用户数据：** 如果您连接 Google 日历，我们会访问您的日历数据以：
    *   检查您的可用性以防止重复预订。
    *   在预订预约时在您的日历中创建新事件。
    *   我们**不会**将您的 Google 日历数据用于任何其他目的，例如广告或市场研究。
*   **日历数据：** 我们存储您连接的日历的配置设置、您创建的事件类型（名称、描述、地点）和预约预订。
*   **日志数据：** 您的 IP 地址暂时存储在服务器日志文件中，用于安全和故障排除。
*   **遥测：** 我们使用 Sentry 收集匿名使用数据和错误报告，以提高应用程序的稳定性。

## 数据共享
我们不会与第三方共享您的个人数据，除非是为了提供服务或法律要求。

*   **Google 用户数据：** 从 Google API 获取的数据**不会**与任何第三方工具、AI 模型或外部实体共享，除非是为了提供日历集成功能（例如，与 Google 服务器通信）。
*   **服务提供商：** 我们使用 Sentry 进行错误跟踪和应用程序监控，以确保服务稳定性。此提供商可能会严格为了服务提供而处理 IP 地址和其他技术数据。
*   **托管：** 应用程序托管在我们自己的基础设施（Kubernetes 集群）上。我们不使用因此获得您数据访问权限的第三方 CDN 或托管提供商。

## 数据存储和保护
您的数据安全地存储在我们的服务器上。
*   **加密：** 您的浏览器和我们服务器之间传输的所有数据都使用 HTTPS 加密。访问令牌等敏感数据以加密方式存储在我们的数据库中。
*   **访问控制：** 对您数据的访问仅限于授权人员，并且仅在支持或维护需要时才访问。

## 数据保留和删除
*   **保留：** 只要您的帐户处于活动状态，我们将保留您的用户资料和日历配置数据。保留预约数据是为了向您提供预定事件的历史记录。
*   **删除：** 您有权请求删除您的数据。您可以随时通过应用程序设置断开 Google 日历的连接，这将删除我们可以访问您的 Google 数据的权限。要请求完全删除帐户和数据，请通过 gawron.christian@fh-swf.de 联系我们，或使用您个人资料设置中的删除帐户功能。

## Google API 服务用户数据政策
AppointMe 使用从 Google API 接收的信息以及将其传输到任何其他应用程序都将遵守 [Google API 服务用户数据政策](https://developers.google.com/terms/api-services-user-data-policy)，包括有限使用要求。`,
    "privacy_content_public": `
# 隐私政策

## 数据处理

为了预订预约，本应用程序处理您提供的数据（姓名、电子邮件地址、描述、预约日期和时间）。这些数据被存储以管理预约，并可能同步到组织者的日历。

## 遥测

我们使用 Sentry 收集匿名遥测数据和错误报告，以提高应用程序的稳定性。`,
    "impressum_content": "# 版本说明\n\n## 免责声明\n此服务器上的内容不属于南威斯特法伦应用技术大学官方在线提供的部分。",
    "CalDav Calendar": "CalDav 日历",
    "loading": "加载中...",
    "Legal": "法律声明",
    "new_event_type": "新事件类型",
    "Appointment Summary": "预约摘要",
    "Could not book event": "无法预订事件",
    "error_no_calendar": "未配置日历集成",
    "error_no_duration": "持续时间必须大于 0",
    "error_no_slots": "未配置时间段",
    "Active": "激活",
    "Inactive": "未激活",
    "delete": "删除",
    "Continue": "继续",
    "Book Appointment": "预订预约",
    "Available Times": "可用时间",
    "No slots available": "无可用时间段",
    "Schedule Appointment": "预约",
    "Available Meeting Types": "可用的会议类型",
    "Please select a meeting type to view availability.": "请选择会议类型以查看可用性。",
    "All": "全部",
    "No public events found.": "未找到公共事件。",
    "Timezone": "时区",
    "Privacy & Terms": "隐私与条款",
    "Quick": "快速",
    "Consulting": "咨询",
    "Tags": "标签",
    "Type a tag and press Enter": "输入标签并按回车",
    "Press Enter to add a tag": "按回车添加标签",
    "Cancel": "取消",
    "landing_hero_title": "预约管理<span class=\"text-primary\">变得简单</span>",
    "landing_hero_subtitle": "Appoint Me 是一个简单且用户友好的预约解决方案。创建事件，分享您的链接，并让其他人与您预约。",
    "landing_cta_start": "立即开始",
    "landing_cta_learn_more": "了解更多",
    "landing_how_it_works_title": "Appoint Me 如何工作",
    "landing_how_it_works_subtitle": "只需四个简单的步骤，即可让您的日历井井有条。",
    "landing_step1_title": "1. 配置日历",
    "landing_step1_desc": "确定 Appoint Me 应在何处输入预约以及应在何处检查您的可用性。连接您的 Google 或 Outlook 日历。",
    "landing_step2_title": "2. 创建事件",
    "landing_step2_desc": "添加您的可用时间，定义持续时间和休息时间，然后开始！",
    "landing_step3_title": "3. 分享您的链接",
    "landing_step3_desc": "通过您的个人链接，客户、同事或朋友可以直接预约，无需烦人的电子邮件往返。",
    "landing_step4_title": "完成！恭喜！",
    "landing_step4_desc": "一旦用户预约，该事件就会自动添加到您的日历中，并且双方都会收到确认。",
    "landing_footer_product": "产品",
    "landing_footer_features": "功能",
    "landing_footer_pricing": "定价",
    "landing_footer_integrations": "集成",
    "landing_footer_resources": "资源",
    "landing_footer_documentation": "文档",
    "landing_footer_api": "API",
    "landing_footer_help_center": "帮助中心",
    "landing_footer_legal": "法律",
    "landing_footer_imprint": "印记",
    "landing_footer_privacy": "隐私",
    "landing_footer_terms": "条款和条件",
    "landing_footer_copyright": COPYRIGHT_ENGLISH,
    "landing_footer_tagline": "适合所有人的简单预约计划。",
    "Contact": "联系方式",
    "footer_credits": "由 South Westphalia University of Applied Sciences ❤️ 实现",
    "terms_of_use_title": "使用条款",
    "terms_of_use_content": "# 使用条款\n\n## 服务提供\n\n此服务免费提供。\n\n## 责任和担保免责声明\n\n作者或 South Westphalia University of Applied Sciences 均不对因使用此服务而造成的任何形式的损害承担任何责任或提供任何形式的担保。使用风险自负。此免责声明不适用于因故意或疏忽违反义务而导致生命、身体或健康受到伤害所造成的损害，也不适用于因故意或重大过失违反义务而造成的其他损害。",
    "my_appointments": "我的预约",
    "no_upcoming_appointments": "未找到即将到来的预约。",
    "appointment": "预约",
    "attendee": "参与者",
    "appointment_details": "预约详情",
    "close": "关闭",
    "event_type": "事件类型",
    "week": "周",
    "work_week": "工作周",
    "day": "天",
    "month": "月",
    "today": "今天",
    "agenda": "议程",
    "more": "更多",
    "next": "下一个",
    "back": "返回",
    "n_more": "还有 {{count}} 项 ...",
    "Recurrence": "重复",
    "Enable Recurring Event": "启用重复事件",
    "Frequency": "频率",
    "Weekly": "每周",
    "Bi-weekly": "每两周",
    "Tri-weekly": "每三周",
    "Monthly": "每月",
    "End Condition": "结束条件",
    "Occurrences": "次数",
    "OR": "或",
    "Until Date": "截止日期",
    "Time Span": "时间跨度",
    "Months": "月",
    "Weeks": "周",
    "Recurring Event": "重复事件",
    "Recurring": "重复",
    "weekly": "每周",
    "biweekly": "每两周",
    "triweekly": "每三周",
    "monthly": "每月",
    "Series Booking Note: Students will book all occurrences at once.": "系列预订说明：学生将一次性预订所有事件。",
    "Feedback": "反馈",
    "Student Only": "仅限学生",
    "Restricted to Students": "仅限学生",
    "Settings exported successfully": "设置导出成功",
    "Failed to export settings": "导出设置失败",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "您确定要导入设置吗？这将覆盖您当前的个人资料和事件。",
    "Settings imported successfully": "设置导入成功",
    "Failed to import settings": "导入设置失败",
    "Invalid file format": "无效的文件格式",
    "Data": "数据",
    "Export Settings": "导出设置",
    "Download your settings and events as a JSON file.": "将您的设置和事件作为 JSON 文件下载。",
    "Export Data": "导出数据",
    "Import Settings": "导入设置",
    "Restore your settings from a JSON file. This will overwrite existing data.": "从 JSON 文件恢复您的设置。这将覆盖现有数据。",
    "Select File": "选择文件",
    "Online Meeting": "在线会议",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "您是通过学习管理系统登录的。请使用课程中提供的特定预订链接进行预约。",
    "Logout": "登出",
    "MyProvider": "我的提供商",
    "Grammatical Gender": "语法性别",
    "Male": "男性",
    "Female": "女性",
    "Neuter": "中性",
    "gender_help_text": "用于确认消息中的正确语法。",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "无法加载变更日志数据。",
    "See what's new and what has been fixed.": "查看最新功能和修复内容。",
    "Reminder setting": "提醒设置",
    "Notification type": "通知类型",
    "System notification": "系统通知",
    "No reminder": "不提醒",
    "Reminder time": "提醒时间",
    "Reminder settings saved": "提醒设置已保存",
    "At event start": "事件开始时",
    "minutes before": "分钟前",
    "1 day before": "提前 1 天",
    "days before": "天前",
    "1 hour before": "提前 1 小时",
    "hours before": "小时前"
};
//# sourceMappingURL=zh.js.map